export default __webpack_public_path__ + "static/media/clientEleven.3b51fe4a.png";